import { render, staticRenderFns } from "./fenlei.vue?vue&type=template&id=00fcbea8&"
import script from "./fenlei.vue?vue&type=script&lang=js&"
export * from "./fenlei.vue?vue&type=script&lang=js&"
import style0 from "./fenlei.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports